package team.platforma.multiplatform_material_extension.ui.password

import androidx.compose.animation.AnimatedVisibility
import androidx.compose.foundation.layout.Box
import androidx.compose.foundation.layout.Column
import androidx.compose.foundation.layout.IntrinsicSize
import androidx.compose.foundation.layout.fillMaxWidth
import androidx.compose.foundation.layout.heightIn
import androidx.compose.foundation.layout.padding
import androidx.compose.foundation.layout.width
import androidx.compose.foundation.text.KeyboardOptions
import androidx.compose.material3.MaterialTheme
import androidx.compose.material3.OutlinedTextField
import androidx.compose.material3.Text
import androidx.compose.material3.TextField
import androidx.compose.material3.TextFieldDefaults
import androidx.compose.runtime.Composable
import androidx.compose.runtime.DisposableEffect
import androidx.compose.runtime.LaunchedEffect
import androidx.compose.runtime.getValue
import androidx.compose.runtime.mutableStateOf
import androidx.compose.runtime.remember
import androidx.compose.runtime.setValue
import androidx.compose.ui.Modifier
import androidx.compose.ui.focus.FocusRequester
import androidx.compose.ui.focus.focusRequester
import androidx.compose.ui.graphics.Color
import androidx.compose.ui.input.key.Key
import androidx.compose.ui.text.input.KeyboardType
import androidx.compose.ui.text.input.PasswordVisualTransformation
import androidx.compose.ui.text.input.VisualTransformation
import androidx.compose.ui.text.intl.Locale
import androidx.compose.ui.text.intl.LocaleList
import androidx.compose.ui.unit.dp
import materialextension.multiplatform_material_extension.generated.resources.Res
import materialextension.multiplatform_material_extension.generated.resources.ic24_mel_eye_close
import materialextension.multiplatform_material_extension.generated.resources.ic24_mel_eye_open
import materialextension.multiplatform_material_extension.generated.resources.mel_hide_password
import materialextension.multiplatform_material_extension.generated.resources.mel_show_password
import team.platforma.multiplatform_material_extension.ui.core.InputField
import team.platforma.multiplatform_material_extension.ui.core.InputFieldProperties
import team.platforma.multiplatform_material_extension.ui.core.InputFieldStateListener
import team.platforma.multiplatform_material_extension.ui.core.StyledTextField
import team.platforma.multiplatform_material_extension.ui.core.field_utils.endIcon
import team.platforma.multiplatform_material_extension.ui.core.global_style.TextFieldColorScheme
import team.platforma.multiplatform_material_extension.ui.core.global_style.area.supportArea
import team.platforma.multiplatform_material_extension.ui.core.global_style.setFiledTextFieldDefaults
import team.platforma.multiplatform_material_extension.ui.core.global_style.setOutlinedTextFieldDefaults
import team.platforma.multiplatform_material_extension.ui.core.global_style.shape.setFilledTextFieldDefaultShape
import team.platforma.multiplatform_material_extension.ui.core.global_style.shape.setOutlineTextFieldDefaultShape
import team.platforma.multiplatform_material_extension.ui.core.rememberInputFieldState
import team.platforma.multiplatform_material_extension.util.forms.FormProperties
import team.platforma.multiplatform_material_extension.util.forms.keyListener
import team.platforma.multiplatform_material_extension.util.forms.rememberForms

@Deprecated("")
object PasswordField : InputField {

    /**
     * val regex: Regex = Regex("^[a-zA-Z0-9!@#$%^&*(),.?\":{}|<>_\\-+=/\\\\~`]*$")
     */
    @Composable
    fun create(
        password: String?,
        modifier: Modifier? = null,
        onPasswordChanged: (change: String, validate: Boolean) -> Unit,
        required: Boolean = true,
        formProperties: FormProperties? = null,
        error: Boolean = false,
        message: String = "",
        validateByForm: Boolean = true
    ): StyledTextField {

        val form by rememberForms()

        val mForm = formProperties ?: FormProperties(form, key = "")

        LaunchedEffect(mForm.key) {
            mForm.form.initValue(mForm.key, password ?: "")
            mForm.form.changeValue(mForm.key, password ?: "")
        }

        return builder(
            PasswordFieldImpl(
                password = password,
                areaModifier = modifier,
                passwordChanged = { change, validate ->
                    onPasswordChanged(change, validate)
                },
                form = mForm,
                required = required,
                validateByForm = validateByForm,
                error = error,
                message = message
            )
        )
    }


    override fun builder(textFieldImpl: StyledTextField): StyledTextField = textFieldImpl
}

@Composable
private fun PasswordFieldImpl(
    password: String?,
    areaModifier: Modifier?,
    passwordChanged: (change: String, validate: Boolean) -> Unit,
    form: FormProperties,
    required: Boolean,
    validateByForm: Boolean,
    error: Boolean,
    message: String
): StyledTextField {
    val inputFieldState = rememberInputFieldState()

    val focusRequester = remember { FocusRequester() }
    val index = remember { form.form.registerFocus(focusRequester) }


    var mPassword by remember { mutableStateOf(password ?: "") }

    var hidePassword by remember { mutableStateOf(true) }

//    if (validateByForm) {
    LaunchedEffect(Unit) {
        form.form.changeValue(form.key, mPassword)
        if (required) {
            form.form.setValidateState(form.key, mPassword.length >= 6)
        } else {
            if (mPassword.isNotEmpty()) {
                form.form.setValidateState(form.key, mPassword.length >= 6)
            } else {
                form.form.setValidateState(form.key, true)
            }
        }
    }
//    }

    var isError by remember { mutableStateOf(false) }

    LaunchedEffect(error) {
        isError = error
    }

    var helpMessage by remember { mutableStateOf("") }

    LaunchedEffect(message) {
        helpMessage = message
    }


    DisposableEffect(inputFieldState) {

        val listener = object : InputFieldStateListener {

            override fun onEndIconClick() {
                hidePassword = !hidePassword
            }

            val regex: Regex = Regex("^[a-zA-Z0-9!@#$%^&*(),.?\":{}|<>_\\-+=/\\\\~`]*$")

            override fun onValueChange(string: String) {
                mPassword = string
                var validate = false
                form.form.changeValue(form.key, mPassword)
                if (validateByForm) {
                    if (required) {
                        form.form.setValidateState(
                            form.key,
                            mPassword.length >= 6 && regex.matches(mPassword)
                        )
                    } else {
                        if (mPassword.isNotEmpty()) {
                            form.form.setValidateState(
                                form.key,
                                mPassword.length >= 6 && regex.matches(mPassword)
                            )
                        } else {
                            form.form.setValidateState(form.key, true)
                        }
                    }
                } else {
                    if (required) {
                        validate = mPassword.length >= 6
                    } else {
                        if (mPassword.isNotEmpty()) {
                            validate = mPassword.length >= 6
                        } else {
                            validate = true
                        }
                    }
                }

                passwordChanged(mPassword, validate)
            }
        }

        inputFieldState.addListener(listener)

        onDispose {
            inputFieldState.removeListener(listener)
        }
    }

    return object : StyledTextField {
        @Composable
        override fun Outline(properties: InputFieldProperties?) {
            Column(
                modifier = (areaModifier ?: Modifier).width(IntrinsicSize.Min)
            ) {
                OutlinedTextField(
                    value = mPassword,
                    onValueChange = { change ->
                        inputFieldState.changeValue(change.trim())
                    },
                    trailingIcon = {
                        endIcon(
                            if (hidePassword) Res.drawable.ic24_mel_eye_close
                            else Res.drawable.ic24_mel_eye_open,
                            inputFieldState
                        )
                    },
                    visualTransformation = if (hidePassword) PasswordVisualTransformation() else VisualTransformation.None,
                    label = properties?.label,
                    placeholder = properties?.placeholder,
                    keyboardOptions = KeyboardOptions.Default.copy(
                        keyboardType = KeyboardType.Password,
                        hintLocales = LocaleList(Locale("en"))
                    ),
                    modifier = (properties?.modifier ?: Modifier)
                        .keyListener(Key.Tab) {
                            form.form.moveToNextFocus(index)
                        }.focusRequester(focusRequester),
                    shape = properties?.shape ?: setOutlineTextFieldDefaultShape(),
                    colors = properties?.colors ?: setOutlinedTextFieldDefaults(),
                    isError = isError
                )
                Column(
                    modifier = Modifier.heightIn(min = supportArea()).fillMaxWidth()
                ) {
                    AnimatedVisibility(helpMessage.isNotEmpty()) {
                        val helperTextColors = properties?.colors ?: setOutlinedTextFieldDefaults()
                        Text(
                            modifier = Modifier.padding(horizontal = 16.dp),
                            text = helpMessage,
                            color = if (isError) helperTextColors.errorSupportingTextColor else helperTextColors.focusedSupportingTextColor,
                            style = MaterialTheme.typography.bodySmall
                        )
                    }
                }
            }

        }

        @Composable
        override fun Filled(properties: InputFieldProperties?) {
            Column(
                modifier = (areaModifier ?: Modifier).width(IntrinsicSize.Min)
            ) {
                TextField(
                    value = mPassword,
                    onValueChange = { change ->
                        inputFieldState.changeValue(change.trim())
                    },
                    trailingIcon = {
                        endIcon(
                            if (hidePassword) Res.drawable.ic24_mel_eye_close
                            else Res.drawable.ic24_mel_eye_open,
                            inputFieldState
                        )
                    },
                    visualTransformation = if (hidePassword) PasswordVisualTransformation() else VisualTransformation.None,
                    label = properties?.label,
                    placeholder = properties?.placeholder,
                    keyboardOptions = KeyboardOptions.Default.copy(
                        keyboardType = KeyboardType.Password,
                        hintLocales = LocaleList(Locale("en"))
                    ),
                    modifier = (properties?.modifier ?: Modifier)
                        .keyListener(Key.Tab) {
                            form.form.moveToNextFocus(index)
                        }.focusRequester(focusRequester),
                    shape = properties?.shape ?: setFilledTextFieldDefaultShape(),
                    colors = properties?.colors ?: setFiledTextFieldDefaults(),
                    isError = isError
                )
                Column(
                    modifier = Modifier.heightIn(min = supportArea()).fillMaxWidth()
                ) {
                    AnimatedVisibility(helpMessage.isNotEmpty()) {
                        val helperTextColors = properties?.colors ?: setFiledTextFieldDefaults()
                        Text(
                            modifier = Modifier.padding(horizontal = 16.dp),
                            text = helpMessage,
                            color = if (isError) helperTextColors.errorSupportingTextColor else helperTextColors.focusedSupportingTextColor,
                            style = MaterialTheme.typography.bodySmall
                        )
                    }
                }
            }

        }

    }
}